import Routes from "./Routes";

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
